import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { useAuth } from '../lib/auth';
import { Icon, type IconName } from './Icon';

/** Pages that need an account show a friendly prompt instead of an API error. */
export function RequireLogin({ icon, title, children }: { icon: IconName; title: string; children: ReactNode }) {
  const { me } = useAuth();
  if (!me) return <p className="page muted">加载中…</p>;
  if (me.user) return <>{children}</>;
  return (
    <div className="page">
      <div className="empty-state" style={{ marginTop: 24 }}>
        <div className="empty-icon">
          <Icon name={icon} />
        </div>
        <h3>{title}</h3>
        <p className="muted">登录后，生词、复习进度和资料会保存在你的账号里，网页和 App 同步。</p>
        <Link className="button primary" to="/me">
          去登录
        </Link>
      </div>
    </div>
  );
}
